export function urgentMessage() {
    let $headerUrgentMessage = $(".header-urgent-message");

    function message() {
        if ($headerUrgentMessage.length) {
            let massageHeight = $headerUrgentMessage.innerHeight();
            $(".footer").css({"padding-bottom": massageHeight});
        }
    }

    $(window).on("load resize", function () {
        message();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/urgentMessage.js